import { loggerNamespace } from '../lib/Logger'
import { rpc } from '../lib/Rpc'

class BusinessService {
  private logger = loggerNamespace('BusinessService')

  public search = async (query: string): Promise<IBusinessSearchItem[]> => {
    if (query.length <= 2) {
      return []
    }

    const payload: TObjectAny = {
      fields: ['id', 'general_info'],
    }
    if (!isNaN(query as any)) {
      payload.id = Number(query)
    } else {
      payload.name = query
    }
    const { error, result } = await rpc.call<IBusinessSearchItem[]>('business.search_businesses', payload)
    return result || []
  }
}

export interface IBusinessSearchItem {
  id: string
  general_info: {
    name: string
    [key: string]: any
  }
}

const businessService = new BusinessService()
export { businessService }
